import React from "react";
import PropTypes from "prop-types";
import PopUpPanel from "../PopUpPanel/PopUpPanel";
import "./AssetConflictModal.scss";

const AssetConflictModal = ({ requestedFilename, suggestedFilename, onOverwrite, onCreateNew }) => {
    return (
        <PopUpPanel showCloseBtn={false} className="asset-conflict-modal">
            <div className="form-holder co-popup-content asset-conflict-modal__content">
                <h2>Asset Already Exists</h2>
                <p>
                    <strong>{requestedFilename}</strong> already exists in this asset library.
                </p>
                <p>
                    Choose whether to replace the existing file or save this upload as <strong>{suggestedFilename}</strong>.
                </p>
                <div className="asset-conflict-modal__actions">
                    <button className="standard-button" type="button" onClick={onOverwrite}>
                        Overwrite
                    </button>
                    <button className="standard-button" type="button" onClick={onCreateNew}>
                        Create New
                    </button>
                </div>
            </div>
        </PopUpPanel>
    );
};

AssetConflictModal.propTypes = {
    requestedFilename: PropTypes.string.isRequired,
    suggestedFilename: PropTypes.string.isRequired,
    onOverwrite: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
};

export default AssetConflictModal;